import { ADD_CART, CLEAR_CART, COUPON, DELETE_CART, EDIT_QTY_CART } from "../types/checkout";

export const addCart = (item) => async (dispatch) => {
  dispatch({
    type: ADD_CART,
    payload: item,
  });
};

export const editQtyCart = (item) => async (dispatch) => {
  dispatch({
    type: EDIT_QTY_CART,
    payload: item,
  });
};

export const deleteCart = (id) => async (dispatch) => {
  dispatch({
    type: DELETE_CART,
    payload: id,
  });
};

export const clearCart = () => async (dispatch) => {
  dispatch({
    type: CLEAR_CART,
  });
};

export const setcoupon = (data) => async (dispatch) => {
  dispatch({
    type: COUPON,
    payload: data,
  });
};
